<div class="min-h-full">
    <nav class="bg-gray-800 fixed w-full z-40">
      <div class="mx-2 px-4 sm:px-6 lg:px-8">
        <div class="flex h-16 items-center justify-between">
                    <div class="flex items-center">
            <div class="shrink-0">
              <a href="#/collections" class=" text-white" aria-current="page"><img class="size-8" src="celia.png" alt="celia"></a>
            </div>
            <div>
              <div class="ml-5 flex items-baseline space-x-4">
                <a href="#/collections" class=" text-white" aria-current="page">Panel ChromaDB <small>v{{appVersion}}</small></a>
              </div>
            </div>          
          </div>
          <button *ngIf="authService.isSignedIn()"
            (click)="onLogout()" 
            class="flex items-center gap-2 bg-red-600 text-white px-4 py-2 rounded-md hover:bg-red-700 transition duration-150 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 text-sm font-medium"
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
              <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75" />
            </svg>
            <span class="hidden md:block">Salir</span>            
          </button>            
        </div>
      </div>
  
      <!-- Mobile menu, show/hide based on menu state. -->
       <!--
      <div class="md:hidden" id="mobile-menu">
        <div class="space-y-1 px-2 pb-3 pt-2 sm:px-3">
          <a href="collections" class="rounded-md bg-gray-900 px-3 py-2 text-sm font-medium text-white" aria-current="page">Collections</a>
        </div>
      </div>
      -->
    </nav>
  
    <header class="bg-white shadow">
      <div class="flex justify-center px-4 py-5 sm:px-6 lg:px-8 cursor-pointer">
        <h1 (click)="onReload()" class="text-3xl font-bold tracking-tight text-gray-900 mt-16">{{pageTitle()}}</h1>
      </div>
    </header>
    <main>
      <div class="mx-auto max-w-7xl px-4 py-4 sm:px-6 lg:px-8">
        <!-- Your content -->
      </div>
    </main>
  </div>
  